type CollapseAllIconProps = {
  className?: string;
};

const CollapseAll = ({ className }: CollapseAllIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 20L12 15L17 20"
      stroke="#145758"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 4L12 9L7 4"
      stroke="#145758"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CollapseAll;
